var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 6,
    fill: "#EFF6FF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1722_27195)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1722_27195",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 7H7V27H27V7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1722_27195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.168 24.7087H12.8346C9.79297 24.7087 8.04297 22.9587 8.04297 19.917V14.0837C8.04297 11.042 9.79297 9.29199 12.8346 9.29199H21.168C24.2096 9.29199 25.9596 11.042 25.9596 14.0837V19.917C25.9596 22.9587 24.2096 24.7087 21.168 24.7087ZM12.8346 10.542C10.4513 10.542 9.29297 11.7003 9.29297 14.0837V19.917C9.29297 22.3003 10.4513 23.4587 12.8346 23.4587H21.168C23.5513 23.4587 24.7096 22.3003 24.7096 19.917V14.0837C24.7096 11.7003 23.5513 10.542 21.168 10.542H12.8346Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 20.125C15.275 20.125 13.875 18.725 13.875 17C13.875 15.275 15.275 13.875 17 13.875C18.725 13.875 20.125 15.275 20.125 17C20.125 18.725 18.725 20.125 17 20.125ZM17 15.125C15.9667 15.125 15.125 15.9667 15.125 17C15.125 18.0333 15.9667 18.875 17 18.875C18.0333 18.875 18.875 18.0333 18.875 17C18.875 15.9667 18.0333 15.125 17 15.125Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8359 13.459H20.3359C19.9943 13.459 19.7109 13.1757 19.7109 12.834C19.7109 12.4923 19.9943 12.209 20.3359 12.209H22.8359C23.1776 12.209 23.4609 12.4923 23.4609 12.834C23.4609 13.1757 23.1776 13.459 22.8359 13.459Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.668 21.792H11.168C10.8263 21.792 10.543 21.5087 10.543 21.167C10.543 20.8253 10.8263 20.542 11.168 20.542H13.668C14.0096 20.542 14.293 20.8253 14.293 21.167C14.293 21.5087 14.0096 21.792 13.668 21.792Z",
    fill: "#002857"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1722_27195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalary);
export default __webpack_public_path__ + "static/media/salary.b728426696ccc002ad429e45e4cb2d1e.svg";
export { ForwardRef as ReactComponent };